import React, { useEffect } from "react";
import UIBody from "../../../components/ui/UIBody";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import { Link } from "react-router-dom";

const KIdsCoursePage = () => {

    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
useEffect(() => {
  callAPI("get", "kids-programs");
}, []);
  return (
    <UIBody
    loading={loading}
      content={
        <div>
          <section className="kids-hero-section pt-5 ">
            <div className="container">
              <div className="row align-items-end">
                {/* Left image (boy) - hidden on small screens */}
                <div
                  className="col-md-3 d-none d-md-block text-center "
                  data-aos="fade-up-right"
                  data-aos-delay="800"
                >
                  <img
                    src="/images/ui/kids/icbox-filler-img-01.webp"
                    alt="Happy Boy"
                    className="img-fluid kids-hero-left-img"
                  />
                </div>

                {/* Center content */}
                <div className="col-md-5 text-center text-md-start  mb-22 bg-white py-4 rounded ">
                  <p
                    className="text-uppercase text-kids-pink fw-bold mb-2"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    Encourages Learning
                  </p>
                  <h1
                    className="fw-bold display-6 mb-3 kids-hero-heading"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    Learn, Play, Grow <br /> The Future of Kid’s Learning
                  </h1>
                  <p
                    className="text-muted mb-4 kids-hero-desc"
                    data-aos="fade-right"
                    data-aos-delay="600"
                  >
                    Unlock your child’s potential with fun, interactive courses
                    designed to inspire creativity, boost confidence, and build
                    future-ready skills—all through the power of play and
                    exploration.
                  </p>

                 

                  {/* <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                    <button
                      className="btn "
                      data-aos="fade-right"
                      data-aos-delay="400"
                    >
                      Get Started →
                    </button>
                  </div> */}
                </div>

                {/* Right circular image - hidden on small screens */}
                <div
                  className="col-md-3 d-none d-md-block text-center pb-5"
                  data-aos="fade-up-left"
                  data-aos-delay="800"
                >
                  <div className="kids-hero-circle-wrapper mx-auto">
                    <img
                      src="/images/ui/programe-step/kids/bn1.jpg"
                      alt="Kids Playing"
                      className="img-kids rounded-circle h-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="position-absolute bottom-0 d-none d-md-block w-100 kids-hero-bottom-img">
              <img
                src="/images/ui/kids/Screenshot 2025-05-18 193541.png"
                alt=""
                class="injectable"
              />
            </div>
          </section>

          <section className="all-courses-area py-4">
            <div className="container">
              <div className="row">
                  {responce?.data?.map((course) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 mb-4"
                    key={course.id}
                  >
                    <div className="courses__item shine__animate-item me-1">
                      <div className="courses__item-thumb">
                         <Link to={`/program/details/${course.slug}`}>
                          <img
                            src={course.image}
                            alt="course"
                            className="img-fluid"
                          />
                        </Link>
                      </div>
                      <div className="courses__item-content">
                        <ul className="courses__item-meta list-wrap">
                          <li className="courses__item-tag">
                           <Link to={`/program/details/${course.slug}`}>{course.tag}</Link>
                          </li>
                          <li className="avg-rating">
                            <i className="fas fa-star"></i> ({course.rating}{" "}
                            Reviews)
                          </li>
                        </ul>
                        <h5 className="title m-0">
                         <Link to={`/program/details/${course.slug}`}>{course.name}</Link>
                        </h5>
                        <p className="courses_mini_titile my-2">
                                                   {course.description}

                        </p>
                        <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                          <div className="courses__item_point">
                            <i className="fas fa-book px-2"></i>
                            {course.duration}
                          </div>
                          <div className="courses__item_point">
                            <i className="fas fa-tasks px-2"></i>
                            {course.activities}
                          </div>
                        </div>
                        <ul className="list-unstyled d-flex flex-column gap-1 py-2">
                          {course.learning_points.map((learning_points, index) => (
                            <li
                              key={index}
                              className="d-flex align-items-center"
                            >
                              <i className="fas fa-check-circle text-success me-2"></i>
                              <span>{learning_points}</span>
                            </li>
                          ))}
                        </ul>

                        <div className="">
                            <Link to={`/program/details/${course.slug}`}> <button className="btn w-100 text-white rounded">
                            Enroll Now
                          </button></Link>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="kids-join-section py-5">
            <div className="kids-join-container">
              <div className="kids-join-row">
                {/* Left Image */}
                <div
                  className="kids-join-image"
                  data-aos="fade-up-right"
                  data-aos-delay="400"
                >
                  <img
                    src="/images/ui/kids/c7pz_yd7m_230601.jpg"
                    alt="Boy with Backpack"
                    className="kids-join-img-fluid"
                  />
                </div>

                {/* Content */}
                <div className="kids-join-content">
                  <p
                    className="kids-join-label"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    LOVED BY KIDS
                  </p>
                  <h2
                    className="kids-join-heading"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    Join Today & Become Confident Learner
                  </h2>
                  <h3 className="mb-5">Simple Steps to Start Learning</h3>

                  <div className="kids-join-steps mb-4">
                    {/* Step 1 */}
                    <div className="kids-join-step">
                      <div className="kids-join-icon kids-join-orange">
                        <i className="bi bi-globe fs-3"></i>
                      </div>
                      <h5 className="kids-join-step-title">
                        1. Explore Our Website
                      </h5>
                      <p className="kids-join-step-text">
                        Discover fun courses, games, and videos designed just
                        for kids like you!
                      </p>
                    </div>

                    {/* Step 2 */}
                    <div className="kids-join-step">
                      <div className="kids-join-icon kids-join-red">
                        <i className="bi bi-mortarboard fs-3"></i>
                      </div>
                      <h5 className="kids-join-step-title">
                        2. Pick What You Love
                      </h5>
                      <p className="kids-join-step-text">
                        Choose from drawing, math, reading, coding, and much
                        more!
                      </p>
                    </div>

                    {/* Step 3 */}
                    <div className="kids-join-step">
                      <div className="kids-join-icon kids-join-orange">
                        <i className="bi bi-door-open fs-3"></i>
                      </div>
                      <h5 className="kids-join-step-title">
                        3. Join Exciting Classes
                      </h5>
                      <p className="kids-join-step-text">
                        Learn at your own pace with friendly teachers and fun
                        activities.
                      </p>
                    </div>

                    {/* Step 4 */}
                    <div className="kids-join-step">
                      <div className="kids-join-icon kids-join-red">
                        <i className="bi bi-play-circle fs-3"></i>
                      </div>
                      <h5 className="kids-join-step-title">
                        4. Start Learning & Growing
                      </h5>
                      <p className="kids-join-step-text">
                        Make new friends, earn badges, and become a superstar
                        learner!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Rocket Image */}
              <img
                src="/images/ui/kids/anim-img-01.png"
                alt="Rocket Kid"
                className="kids-join-rocket"
                data-aos="fade-down-right"
                data-aos-delay="400"
              />
            </div>

            <div className="position-absolute bottom-0 d-none d-md-block w-100 kids-learning-bottom-img">
              <img
                src="/images/ui/kids/Screenshot 2025-05-18 191902.png"
                alt=""
                className="injectable"
              />
            </div>
          </section>

          <section class="kids-curriculum-section py-5 mb-5">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-5 d-none d-lg-block">
                  <div
                    class="position-relative text-center"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <img
                      src="/images/ui/kids/blob-img.webp"
                      alt="Kids"
                      class="img-fluid kids-curriculum-image"
                    />
                    <img
                      src="images/ui/kids/sunflower.png"
                      class="position-absolute top-0 start-0 translate-middle d-none d-md-block"
                      width="90"
                      alt="Decor Star"
                    />
                  </div>
                </div>

                <div
                  class="col-lg-7 position-relative"
                  data-aos="fade-left"
                  data-aos-delay="400"
                >
                  <p class="text-uppercase text-muted fw-bold">
                    Unlimited Learning
                  </p>
                  <h2 class="fw-bold display-5">
                    Complete Learning for <br /> Every Young Mind
                  </h2>
                  <p class="text-muted mb-4">
                    Encouraging kids to explore, imagine, and grow with a
                    well-rounded curriculum designed just for them. Our approach
                    blends creativity, curiosity, and care to make every moment
                    meaningful.
                  </p>

                  <div class="kids-feature-item d-flex align-items-start mb-4">
                    <div class="feature-icon bg-purple text-white me-3">01</div>
                    <div>
                      <h5 class="fw-bold mb-1">Joyful Learning Experience</h5>
                      <p class="text-muted mb-0">
                        We make learning fun with storytelling, hands-on
                        activities, and games that keep kids excited and engaged
                        every day.
                      </p>
                    </div>
                  </div>

                  <div class="kids-feature-item d-flex align-items-start mb-4">
                    <div class="feature-icon bg-pink text-white me-3">02</div>
                    <div>
                      <h5 class="fw-bold mb-1">Safe & Happy Environment</h5>
                      <p class="text-muted mb-0">
                        A secure, cheerful space where every child feels valued,
                        comfortable, and ready to learn with confidence.
                      </p>
                    </div>
                  </div>

                  <div class="kids-feature-item d-flex align-items-start mb-4">
                    <div class="feature-icon bg-blue text-white me-3">03</div>
                    <div>
                      <h5 class="fw-bold mb-1">
                        Colorful, Kid-Friendly Classrooms
                      </h5>
                      <p class="text-muted mb-0">
                        Our vibrant classrooms are equipped with fun visuals,
                        learning tools, and playful decor to spark creativity
                        and focus.
                      </p>
                    </div>
                  </div>

                  <a href="#" class="btn btn-kids-gradient rounded-pill  mt-3">
                    More About Us →
                  </a>
                  <img
                    src="/images/ui/kids/group-young-children-cartoon-character.png"
                    class="position-absolute bottom-0 end-0 d-none d-md-block"
                    width="290"
                    alt="Yellow dots"
                  />
                </div>
              </div>
            </div>
          </section>

          
        </div>
      }
    />
  );
};

export default KIdsCoursePage;
